import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { API_URL_GET_DETAIL_EVALUATION } from "manager/http-constants";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import { MessageData, ToastMessageData } from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { LoginService } from "src/app/shared/service/login.service";
import { PlatformComponent } from "../../platform.component";

@Component({
  selector: "app-pub-evaluation-dialog",
  templateUrl: "./pub-evaluation-dialog.component.html",
  styleUrls: ["./pub-evaluation-dialog.component.scss"],
})
export class PubEvaluationDialogComponent extends PlatformComponent {
  @Output() returnStatusDialog = new EventEmitter<boolean>();
  @Input() matchId: string;

  boardFlag: boolean = false;
  roleValue: string;

  data: any[] = [];
  class_id: any = "";

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    this.openRoleDialog();
  }

  public openRoleDialog(): void {
    this.boardFlag = true;
  }

  public closeDialog(): void {
    this.boardFlag = false;
    this.returnStatusDialog.emit(this.boardFlag);
  }

  ngAfterViewInit() {
    this.getDetailTask();
  }

  public getDetailTask(): void {
    this.loadingState.loadStart(API_URL_GET_DETAIL_EVALUATION);

    this.dbOperationService
      .getNoTemplateDisplayData(API_URL_GET_DETAIL_EVALUATION, this.matchId)
      .subscribe((response) => {
        this.loadingState.loadSleepEnd(0.3, API_URL_GET_DETAIL_EVALUATION);

        if (this.commonService.checkInvalidValue(response)) {
          this.closeDialog();
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          return;
        } else if (this.commonService.checkNoneResponse(response)) {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
        } else {
          this.data.push(response.body);
        }
      });
  }

  public formatDateJapan(implementation_date: any) {
    let date = new Date(implementation_date);
    let lang = "en",
      year = date.toLocaleString(lang, { year: "numeric" }),
      month = date.toLocaleString(lang, { month: "numeric" }),
      day = date.toLocaleString(lang, { day: "numeric" });
    return `${year}年 ${month}月 ${day}日`;
  }
}
